var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitycenterColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.811 1.16599H19.501V20.638H24.811V1.16599Z",
    fill: "url(#paint0_linear_3084_158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4487 0.956009H23.8487V0.266998H24.2987V0H20.0537V0.266998H20.4537L20.4487 0.956009Z",
    fill: "url(#paint1_linear_3084_158)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2788 2.23701H28.7288V1.97H25.4038V2.92601H28.2788V2.23701Z",
    fill: "url(#paint2_linear_3084_158)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1619 3.2L33.8289 3.132L33.8359 2.92599L29.8359 3.371V4.088H33.3859L33.1619 3.2Z",
    fill: "url(#paint3_linear_3084_158)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3789 12.659C34.3098 9.8505 33.9905 7.05378 33.4249 4.30199H29.8419V20.64H29.2419V3.13998H25.4009V20.64H29.0659C29.0659 20.65 34.3759 20.64 34.3759 20.64C34.3759 20.64 34.4699 17.449 34.3789 12.659Z",
    fill: "url(#paint4_linear_3084_158)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5879 2.23701H16.0379V2.92601H18.9129V1.97H15.5879V2.23701Z",
    fill: "url(#paint5_linear_3084_158)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2478 20.639H18.9128V3.13901H15.0718V20.639",
    fill: "url(#paint6_linear_3084_158)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1551 3.2L10.9261 4.08899H14.4761V3.37199L10.4761 2.927L10.4831 3.133L11.1551 3.2Z",
    fill: "url(#paint7_linear_3084_158)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91091 19.111C10.3778 19.7031 10.9334 20.2195 11.5579 20.642C13.1199 20.642 15.2479 20.642 15.2479 20.642H15.0719H14.4719V4.29901H10.8889C10.3234 7.05082 10.0041 9.84754 9.93491 12.656C9.88491 15.465 9.89391 17.722 9.91091 19.111Z",
    fill: "url(#paint8_linear_3084_158)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58789 18.666C9.81949 19.0094 10.0798 19.3326 10.3659 19.632H40.3859L40.7369 18.666H9.58789Z",
    fill: "url(#paint9_linear_3084_158)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5559 22.678C19.5578 22.6973 19.5578 22.7167 19.5559 22.736C19.5497 22.7561 19.5424 22.7758 19.5339 22.795C19.5272 22.8176 19.5188 22.8396 19.5089 22.861V22.867L19.5029 22.877C19.3517 23.1399 19.1847 23.3933 19.0029 23.636H38.9369L39.2869 22.676L19.5559 22.678Z",
    fill: "url(#paint10_linear_3084_158)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5518 20.638C12.1351 21.033 12.7657 21.3532 13.4288 21.591H39.6728L40.0198 20.638H11.5518Z",
    fill: "url(#paint11_linear_3084_158)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2178 22.488H77.1648",
    stroke: "black",
    strokeWidth: 1.416
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8231 14.637C76.7825 14.6362 76.742 14.6436 76.7043 14.6589C76.6666 14.6742 76.6324 14.697 76.6038 14.7259C76.5752 14.7548 76.5527 14.7892 76.5378 14.827C76.5229 14.8649 76.5159 14.9054 76.5171 14.946V16.038C76.5258 16.1827 76.5038 16.3275 76.4526 16.463C76.4013 16.5985 76.322 16.7217 76.2199 16.8244C76.1177 16.9272 75.995 17.0071 75.8597 17.0591C75.7245 17.1111 75.5798 17.1339 75.4351 17.126H74.6791C74.923 16.8161 75.0539 16.4323 75.0501 16.038V14.946C75.0525 14.9042 75.0463 14.8623 75.032 14.8229C75.0176 14.7835 74.9953 14.7475 74.9665 14.717C74.9377 14.6865 74.903 14.6622 74.8645 14.6456C74.826 14.629 74.7845 14.6205 74.7426 14.6205C74.7007 14.6205 74.6592 14.629 74.6207 14.6456C74.5822 14.6622 74.5475 14.6865 74.5187 14.717C74.4899 14.7475 74.4677 14.7835 74.4533 14.8229C74.4389 14.8623 74.4327 14.9042 74.4351 14.946V16.038C74.4441 16.1827 74.4223 16.3277 74.3712 16.4634C74.3201 16.599 74.2408 16.7223 74.1386 16.8251C74.0364 16.928 73.9135 17.0079 73.7781 17.0598C73.6427 17.1116 73.4979 17.1342 73.3531 17.126H72.8881C73.1323 16.8163 73.2632 16.4324 73.2591 16.038V14.946C73.2591 14.8641 73.2266 14.7855 73.1686 14.7275C73.1107 14.6696 73.0321 14.637 72.9501 14.637C72.91 14.637 72.8702 14.6451 72.8332 14.6607C72.7962 14.6763 72.7627 14.6992 72.7347 14.728C72.7068 14.7569 72.6849 14.791 72.6703 14.8284C72.6558 14.8659 72.6489 14.9059 72.6501 14.946V16.038C72.6588 16.1829 72.6368 16.3279 72.5854 16.4636C72.5341 16.5994 72.4546 16.7227 72.3523 16.8255C72.2499 16.9284 72.1269 17.0084 71.9914 17.0604C71.8559 17.1123 71.711 17.135 71.5661 17.127H64.2131C64.4597 16.8186 64.5912 16.4339 64.5851 16.039V14.947C64.5851 14.866 64.5529 14.7883 64.4956 14.731C64.4383 14.6737 64.3607 14.6415 64.2796 14.6415C64.1986 14.6415 64.1209 14.6737 64.0636 14.731C64.0063 14.7883 63.9741 14.866 63.9741 14.947V16.039C63.9826 16.1836 63.9605 16.3284 63.9092 16.4638C63.858 16.5993 63.7786 16.7224 63.6765 16.8251C63.5744 16.9278 63.4517 17.0078 63.3166 17.0598C63.1814 17.1118 63.0368 17.1347 62.8921 17.127H58.6921C58.9369 16.8177 59.0675 16.4334 59.0621 16.039V14.947C59.0621 14.866 59.0299 14.7883 58.9727 14.731C58.9154 14.6737 58.8376 14.6415 58.7566 14.6415C58.6756 14.6415 58.5979 14.6737 58.5406 14.731C58.4833 14.7883 58.4511 14.866 58.4511 14.947V16.039C58.4597 16.1836 58.4375 16.3284 58.3862 16.4638C58.3349 16.5993 58.2557 16.7224 58.1535 16.8251C58.0514 16.9278 57.9287 17.0078 57.7935 17.0598C57.6584 17.1118 57.5138 17.1347 57.3691 17.127H53.0781V16.332C53.0781 16.2514 53.0461 16.1741 52.9891 16.1171C52.9321 16.0601 52.8548 16.028 52.7741 16.028C52.6935 16.028 52.6162 16.0601 52.5592 16.1171C52.5022 16.1741 52.4701 16.2514 52.4701 16.332V17.432C52.4787 17.5764 52.4566 17.721 52.4053 17.8562C52.3539 17.9914 52.2746 18.1142 52.1723 18.2165C52.0701 18.3188 51.9474 18.3983 51.8122 18.4498C51.6771 18.5012 51.5325 18.5235 51.3881 18.515H46.4691C46.3874 18.515 46.3091 18.5475 46.2513 18.6052C46.1936 18.663 46.1611 18.7413 46.1611 18.823C46.1611 18.9047 46.1936 18.9831 46.2513 19.0408C46.3091 19.0986 46.3874 19.131 46.4691 19.131H51.3881C51.7896 19.1441 52.1817 19.0084 52.4892 18.75C52.7967 18.4916 52.9979 18.1287 53.0541 17.731H75.4341C75.6592 17.74 75.8838 17.7023 76.0937 17.6205C76.3036 17.5386 76.4944 17.4142 76.654 17.2552C76.8136 17.0961 76.9386 16.9058 77.0212 16.6962C77.1039 16.4866 77.1423 16.2622 77.1341 16.037V14.946C77.1345 14.9054 77.1268 14.8651 77.1115 14.8275C77.0962 14.7899 77.0735 14.7557 77.0449 14.727C77.0162 14.6982 76.9821 14.6755 76.9445 14.66C76.907 14.6446 76.8667 14.6368 76.8261 14.637H76.8231Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.716 13.436C58.7162 13.5378 58.6862 13.6374 58.6298 13.7222C58.5735 13.807 58.4932 13.8731 58.3993 13.9123C58.3053 13.9515 58.2018 13.962 58.1019 13.9424C58.002 13.9228 57.9101 13.874 57.8379 13.8022C57.7657 13.7304 57.7164 13.6389 57.6963 13.5391C57.6761 13.4393 57.6859 13.3357 57.7246 13.2415C57.7632 13.1473 57.8289 13.0667 57.9134 13.0098C57.9978 12.953 58.0972 12.9224 58.199 12.922C58.2667 12.9217 58.3338 12.9348 58.3965 12.9605C58.4591 12.9862 58.5161 13.024 58.5641 13.0718C58.6121 13.1195 58.6503 13.1763 58.6764 13.2388C58.7024 13.3013 58.7159 13.3683 58.716 13.436Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0871 13.436C60.0873 13.5379 60.0573 13.6376 60.0008 13.7225C59.9442 13.8073 59.8638 13.8735 59.7697 13.9126C59.6755 13.9517 59.5719 13.962 59.4719 13.9422C59.3719 13.9223 59.2801 13.8732 59.208 13.8012C59.1359 13.7291 59.0868 13.6372 59.067 13.5372C59.0471 13.4372 59.0574 13.3336 59.0965 13.2395C59.1356 13.1453 59.2018 13.0649 59.2866 13.0084C59.3715 12.9519 59.4712 12.9218 59.5731 12.922C59.7094 12.9223 59.8399 12.9765 59.9363 13.0728C60.0326 13.1692 60.0869 13.2998 60.0871 13.436Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8328 13.373C64.8332 13.4751 64.8033 13.5749 64.7469 13.66C64.6906 13.7451 64.6102 13.8116 64.5161 13.851C64.422 13.8904 64.3182 13.901 64.2181 13.8815C64.1179 13.862 64.0258 13.8132 63.9533 13.7413C63.8809 13.6694 63.8314 13.5777 63.8111 13.4776C63.7908 13.3776 63.8006 13.2738 63.8393 13.1794C63.878 13.085 63.9438 13.0041 64.0284 12.9471C64.1131 12.8901 64.2127 12.8594 64.3148 12.859C64.3825 12.8587 64.4497 12.8718 64.5124 12.8975C64.5751 12.9232 64.6321 12.961 64.6802 13.0087C64.7283 13.0565 64.7666 13.1132 64.7928 13.1757C64.8189 13.2382 64.8325 13.3053 64.8328 13.373Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.823 7.073C76.7831 7.0722 76.7435 7.07937 76.7064 7.09409C76.6693 7.1088 76.6355 7.13078 76.607 7.15872C76.5785 7.18666 76.5559 7.22 76.5404 7.25679C76.525 7.29358 76.517 7.33309 76.517 7.373V8.47301C76.5256 8.61738 76.5035 8.76194 76.4522 8.89716C76.4009 9.03237 76.3215 9.15518 76.2192 9.25749C76.117 9.35981 75.9943 9.4393 75.8591 9.49075C75.7239 9.5422 75.5794 9.56445 75.435 9.556H74.679C74.9228 9.24799 75.0537 8.86579 75.05 8.47301V7.373C75.0455 7.29448 75.0112 7.22065 74.954 7.16664C74.8968 7.11263 74.8212 7.08255 74.7425 7.08255C74.6639 7.08255 74.5882 7.11263 74.531 7.16664C74.4739 7.22065 74.4395 7.29448 74.435 7.373V8.47301C74.4438 8.61742 74.4218 8.76205 74.3705 8.89734C74.3193 9.03263 74.2399 9.15549 74.1376 9.25784C74.0354 9.36019 73.9125 9.43969 73.7773 9.49109C73.642 9.54248 73.4975 9.56461 73.353 9.556H72.888C73.1308 9.24745 73.2616 8.86561 73.259 8.47301V7.373C73.2572 7.29245 73.2238 7.21585 73.166 7.15973C73.1082 7.10361 73.0306 7.07245 72.95 7.073C72.9106 7.073 72.8716 7.08076 72.8352 7.09584C72.7988 7.11092 72.7657 7.13302 72.7379 7.16087C72.71 7.18873 72.6879 7.2218 72.6729 7.25819C72.6578 7.29459 72.65 7.3336 72.65 7.373V8.47301C72.6585 8.61761 72.6362 8.76236 72.5846 8.89772C72.5331 9.03308 72.4534 9.15599 72.3509 9.25832C72.2484 9.36065 72.1253 9.44008 71.9899 9.49139C71.8544 9.54271 71.7096 9.56473 71.565 9.556H65.795C66.0398 9.24861 66.1706 8.86592 66.165 8.47301V7.373C66.165 7.29171 66.1327 7.21375 66.0753 7.15627C66.0178 7.09879 65.9398 7.0665 65.8585 7.0665C65.7772 7.0665 65.6993 7.09879 65.6418 7.15627C65.5843 7.21375 65.552 7.29171 65.552 7.373V8.47301C65.5609 8.61737 65.5391 8.76197 65.4879 8.89726C65.4368 9.03255 65.3575 9.15544 65.2553 9.25781C65.1531 9.36018 65.0304 9.4397 64.8952 9.4911C64.76 9.54251 64.6154 9.56462 64.471 9.556H60.771C61.0134 9.2475 61.143 8.86532 61.138 8.47301V7.373C61.1336 7.295 61.0994 7.22166 61.0426 7.16801C60.9858 7.11437 60.9107 7.08449 60.8325 7.08449C60.7544 7.08449 60.6792 7.11437 60.6224 7.16801C60.5656 7.22166 60.5315 7.295 60.527 7.373V8.47301C60.5354 8.61734 60.5132 8.76183 60.4619 8.89697C60.4105 9.03212 60.3311 9.15486 60.2289 9.25714C60.1267 9.35942 60.004 9.43892 59.8689 9.49043C59.7338 9.54194 59.5894 9.56429 59.445 9.556H56.324C55.999 9.556 55.724 9.15 55.406 8.69C55.2098 8.26488 54.9064 7.89809 54.5256 7.62564C54.1448 7.3532 53.6997 7.18447 53.234 7.136H48.605C48.255 7.1 47.9013 7.14255 47.5698 7.26057C47.2383 7.3786 46.9374 7.5691 46.6888 7.81821C46.4403 8.06731 46.2505 8.36874 46.1332 8.70052C46.016 9.03229 45.9742 9.38606 46.011 9.73601C46.0173 9.81315 46.0523 9.88512 46.1092 9.93759C46.1661 9.99007 46.2406 10.0192 46.318 10.0192C46.3954 10.0192 46.47 9.99007 46.5269 9.93759C46.5837 9.88512 46.6188 9.81315 46.625 9.73601C46.5872 9.46716 46.6124 9.19321 46.6985 8.93575C46.7847 8.67828 46.9294 8.44434 47.1214 8.25237C47.3134 8.06039 47.5473 7.91564 47.8048 7.8295C48.0622 7.74336 48.3362 7.7182 48.605 7.756H53.234C54.027 7.756 54.473 8.406 54.898 9.034C55.28 9.59 55.677 10.17 56.325 10.17H75.441C75.6661 10.1787 75.8905 10.1408 76.1003 10.0588C76.3101 9.97685 76.5007 9.85247 76.6602 9.6935C76.8198 9.53452 76.9448 9.34436 77.0275 9.13487C77.1103 8.92539 77.1489 8.70109 77.141 8.476V7.37601C77.141 7.33593 77.133 7.29625 77.1174 7.25932C77.1019 7.22239 77.0791 7.18896 77.0504 7.161C77.0216 7.13303 76.9876 7.11109 76.9503 7.0965C76.913 7.0819 76.8731 7.07494 76.833 7.076L76.823 7.073Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3122 9.96301C50.312 10.0648 50.2816 10.1641 50.2248 10.2486C50.1681 10.3331 50.0876 10.3988 49.9935 10.4374C49.8994 10.4761 49.7959 10.486 49.6962 10.4658C49.5965 10.4456 49.505 10.3963 49.4333 10.324C49.3616 10.2518 49.313 10.1599 49.2936 10.0601C49.2742 9.96019 49.2849 9.8568 49.3243 9.76299C49.3637 9.66919 49.43 9.58918 49.5149 9.53311C49.5998 9.47703 49.6994 9.44741 49.8012 9.44801C49.9371 9.4488 50.0673 9.50345 50.163 9.59997C50.2588 9.69649 50.3124 9.82703 50.3122 9.96301Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6863 9.963C51.6863 10.0648 51.6561 10.1643 51.5996 10.2489C51.5431 10.3336 51.4628 10.3996 51.3688 10.4386C51.2748 10.4776 51.1714 10.488 51.0715 10.4683C50.9717 10.4485 50.8799 10.3997 50.8078 10.3279C50.7357 10.256 50.6865 10.1645 50.6664 10.0647C50.6463 9.96492 50.6562 9.86145 50.6949 9.76731C50.7336 9.67317 50.7993 9.5926 50.8837 9.53577C50.9681 9.47894 51.0675 9.4484 51.1693 9.448C51.2371 9.44774 51.3042 9.46086 51.3669 9.48662C51.4297 9.51239 51.4867 9.55028 51.5347 9.59813C51.5827 9.64598 51.6208 9.70285 51.6469 9.76546C51.6729 9.82807 51.6863 9.8952 51.6863 9.963Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7742 6.30501C60.7732 6.42428 60.7309 6.53951 60.6546 6.63113C60.5782 6.72274 60.4725 6.78508 60.3553 6.80753C60.2382 6.82999 60.1169 6.81118 60.0121 6.75429C59.9073 6.69741 59.8254 6.60596 59.7804 6.49552C59.7353 6.38508 59.73 6.26246 59.7652 6.14851C59.8004 6.03455 59.874 5.9363 59.9734 5.87047C60.0729 5.80465 60.192 5.77531 60.3107 5.78744C60.4293 5.79957 60.5401 5.85243 60.6242 5.93702C60.6723 5.98537 60.7104 6.04279 60.7361 6.10596C60.7619 6.16914 60.7748 6.2368 60.7742 6.30501Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1468 6.30501C62.1463 6.42479 62.1042 6.54068 62.0278 6.63294C61.9514 6.7252 61.8454 6.78813 61.7279 6.81102C61.6103 6.83392 61.4884 6.81537 61.383 6.75852C61.2776 6.70167 61.1951 6.61003 61.1496 6.49921C61.1041 6.3884 61.0985 6.26525 61.1336 6.15073C61.1687 6.03621 61.2424 5.9374 61.3422 5.87111C61.442 5.80483 61.5616 5.77518 61.6808 5.78719C61.8 5.7992 61.9113 5.85215 61.9958 5.93702C62.0441 5.98531 62.0823 6.0427 62.1082 6.10587C62.1341 6.16904 62.1473 6.23673 62.1468 6.30501Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1448 11.684C64.145 11.7862 64.1148 11.8861 64.0582 11.9712C64.0015 12.0562 63.9209 12.1225 63.8265 12.1616C63.7321 12.2008 63.6282 12.211 63.528 12.1911C63.4278 12.1711 63.3357 12.1218 63.2636 12.0495C63.1914 11.9772 63.1423 11.8851 63.1225 11.7848C63.1028 11.6846 63.1132 11.5807 63.1525 11.4864C63.1919 11.3921 63.2583 11.3116 63.3435 11.2551C63.4286 11.1986 63.5286 11.1686 63.6308 11.169C63.7671 11.1695 63.8977 11.224 63.994 11.3205C64.0903 11.417 64.1445 11.5477 64.1448 11.684Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5158 11.684C65.5158 11.7859 65.4856 11.8854 65.429 11.9701C65.3725 12.0548 65.292 12.1208 65.1979 12.1598C65.1038 12.1988 65.0003 12.209 64.9004 12.1891C64.8005 12.1692 64.7087 12.1202 64.6367 12.0482C64.5647 11.9761 64.5156 11.8844 64.4957 11.7845C64.4759 11.6846 64.4861 11.581 64.5251 11.4869C64.564 11.3928 64.63 11.3124 64.7147 11.2558C64.7994 11.1992 64.899 11.169 65.0009 11.169C65.1374 11.169 65.2684 11.2233 65.365 11.3199C65.4616 11.4164 65.5158 11.5474 65.5158 11.684Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0629 30.067C49.542 30.0767 50.0209 30.0402 50.493 29.958L50.6559 29.935C50.7949 29.912 50.8489 29.966 50.8489 30.135C50.8489 30.291 50.7949 30.361 50.6559 30.393C50.088 30.4798 49.5144 30.5243 48.9399 30.526C46.8209 30.526 46.2109 29.726 46.2109 28.277C46.2109 26.828 46.8219 26.044 48.9399 26.044C49.5145 26.0457 50.088 26.0901 50.6559 26.177C50.6854 26.1799 50.7139 26.1888 50.7398 26.2031C50.7657 26.2175 50.7883 26.2369 50.8064 26.2603C50.8245 26.2838 50.8376 26.3106 50.8449 26.3393C50.8522 26.3679 50.8536 26.3978 50.8489 26.427C50.8489 26.607 50.7949 26.661 50.6559 26.638L50.493 26.615C50.0209 26.5328 49.542 26.4963 49.0629 26.506C47.3929 26.506 46.9439 26.967 46.9439 28.279C46.9439 29.591 47.3929 30.067 49.0629 30.067Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2351 30.168C57.2351 30.379 57.2201 30.449 56.8951 30.449C56.5471 30.449 56.5391 30.379 56.5391 30.168V26.396C56.5391 26.185 56.5471 26.115 56.8951 26.115C57.2201 26.115 57.2351 26.185 57.2351 26.396V30.168Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.803 26.771C64.8065 26.7426 64.8035 26.7138 64.7943 26.6868C64.7851 26.6597 64.7698 26.6351 64.7497 26.6148C64.7296 26.5945 64.7051 26.579 64.6781 26.5695C64.6512 26.56 64.6224 26.5568 64.594 26.56H62.694C62.555 26.56 62.501 26.498 62.501 26.341C62.501 26.201 62.555 26.115 62.694 26.115H67.603C67.742 26.115 67.796 26.201 67.796 26.341C67.796 26.497 67.742 26.56 67.603 26.56H65.703C65.6746 26.5568 65.6458 26.56 65.6188 26.5695C65.5919 26.579 65.5674 26.5945 65.5473 26.6148C65.5272 26.6351 65.5119 26.6597 65.5027 26.6868C65.4934 26.7138 65.4905 26.7426 65.494 26.771V30.171C65.494 30.382 65.479 30.452 65.162 30.452C64.814 30.452 64.806 30.382 64.806 30.171L64.803 26.771Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8451 29.106C74.7812 29.2257 74.7518 29.3606 74.76 29.496V30.168C74.76 30.379 74.744 30.449 74.428 30.449C74.08 30.449 74.0721 30.379 74.0721 30.168V29.447C74.0748 29.293 74.0165 29.1442 73.9101 29.033L71.8221 26.386C71.6751 26.199 71.7371 26.113 72.0461 26.113C72.4791 26.113 72.4791 26.121 72.6721 26.371L74.1101 28.323C74.2101 28.456 74.2721 28.534 74.4101 28.534H74.51C74.649 28.534 74.7341 28.448 74.8271 28.307L76.195 26.324C76.357 26.105 76.4731 26.113 76.7281 26.113C76.9831 26.113 76.999 26.199 76.906 26.313L74.8451 29.106Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6691 36.06C49.0832 36.0682 49.4972 36.0363 49.9052 35.965L50.0451 35.945C50.1651 35.925 50.2121 35.972 50.2121 36.121C50.2121 36.27 50.1651 36.321 50.0451 36.344C49.554 36.4191 49.058 36.4576 48.5611 36.459C46.7301 36.459 46.2021 35.771 46.2021 34.516C46.2021 33.261 46.7301 32.586 48.5611 32.586C49.058 32.5876 49.554 32.626 50.0451 32.701C50.0706 32.7035 50.0952 32.7113 50.1176 32.7237C50.1399 32.7361 50.1595 32.7529 50.1751 32.7731C50.1907 32.7933 50.2021 32.8165 50.2085 32.8412C50.2148 32.866 50.2161 32.8917 50.2121 32.917C50.2121 33.072 50.1651 33.117 50.0451 33.099L49.9052 33.079C49.4972 33.0077 49.0832 32.9759 48.6691 32.984C47.2261 32.984 46.8381 33.384 46.8381 34.516C46.8381 35.648 47.2261 36.06 48.6691 36.06Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9093 36.391C51.6293 36.391 51.5283 36.296 51.5283 36.04V32.997C51.5283 32.74 51.6283 32.646 51.9093 32.646H55.1033C55.2233 32.646 55.2703 32.72 55.2703 32.846C55.2703 32.972 55.2233 33.035 55.1033 33.035H52.3093C52.2848 33.0321 52.2599 33.0348 52.2365 33.0429C52.2132 33.051 52.1919 33.0644 52.1745 33.0819C52.1571 33.0994 52.1438 33.1207 52.1358 33.1441C52.1278 33.1675 52.1253 33.1924 52.1283 33.217V34.027C52.1253 34.0516 52.1278 34.0764 52.1358 34.0999C52.1438 34.1233 52.1571 34.1445 52.1745 34.1621C52.1919 34.1796 52.2132 34.193 52.2365 34.2011C52.2599 34.2092 52.2848 34.2119 52.3093 34.209H54.4413C54.5613 34.209 54.6083 34.29 54.6083 34.409C54.6083 34.528 54.5613 34.591 54.4413 34.591H52.3093C52.2843 34.5889 52.2591 34.5923 52.2357 34.6012C52.2122 34.6101 52.1909 34.6241 52.1736 34.6422C52.1562 34.6603 52.1431 34.6821 52.1353 34.706C52.1275 34.7298 52.1251 34.7551 52.1283 34.78V35.826C52.1253 35.8505 52.1278 35.8755 52.1358 35.8989C52.1438 35.9223 52.1571 35.9436 52.1745 35.9611C52.1919 35.9786 52.2132 35.992 52.2365 36.0001C52.2599 36.0082 52.2848 36.0109 52.3093 36.008H55.2363C55.3563 36.008 55.4033 36.069 55.4033 36.19C55.4033 36.311 55.3563 36.39 55.2363 36.39L51.9093 36.391Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0889 36.394C59.9749 36.4054 59.8602 36.381 59.7608 36.3242C59.6613 36.2674 59.582 36.181 59.5339 36.077L57.5759 33.148C57.555 33.0994 57.5191 33.0587 57.4733 33.0321C57.4276 33.0054 57.3745 32.9942 57.3219 33C57.1879 33 57.1279 33.027 57.1279 33.189V36.226C57.1279 36.347 57.0749 36.395 56.8739 36.395C56.6729 36.395 56.6069 36.348 56.6069 36.226V32.994C56.6069 32.737 56.6999 32.643 56.9879 32.643H57.6229C57.7378 32.6307 57.8537 32.6547 57.9543 32.7115C58.0548 32.7684 58.1352 32.8552 58.1839 32.96L60.1409 35.889C60.1608 35.9399 60.1976 35.9823 60.2451 36.0093C60.2927 36.0362 60.348 36.046 60.4019 36.037C60.5359 36.037 60.5959 36.01 60.5959 35.848V32.814C60.5959 32.693 60.6559 32.645 60.8569 32.645C61.0579 32.645 61.1179 32.692 61.1179 32.814V36.04C61.1179 36.296 61.0239 36.391 60.7439 36.391L60.0889 36.394Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.052 33.213C64.0551 33.1886 64.0525 33.1637 64.0446 33.1404C64.0366 33.1171 64.0235 33.0959 64.0062 33.0784C63.9888 33.0609 63.9678 33.0475 63.9445 33.0393C63.9213 33.0311 63.8965 33.0282 63.872 33.031H62.228C62.108 33.031 62.061 32.977 62.061 32.842C62.061 32.707 62.108 32.642 62.228 32.642H66.471C66.591 32.642 66.638 32.716 66.638 32.842C66.638 32.968 66.591 33.031 66.471 33.031H64.827C64.8025 33.0281 64.7776 33.0308 64.7542 33.0389C64.7309 33.047 64.7096 33.0604 64.6922 33.0779C64.6748 33.0954 64.6615 33.1167 64.6535 33.1401C64.6455 33.1635 64.643 33.1885 64.646 33.213V36.149C64.646 36.331 64.632 36.392 64.359 36.392C64.059 36.392 64.051 36.331 64.051 36.149L64.052 33.213Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.962 36.391C67.681 36.391 67.5811 36.296 67.5811 36.04V32.997C67.5811 32.74 67.681 32.646 67.962 32.646H71.156C71.276 32.646 71.3231 32.72 71.3231 32.846C71.3231 32.972 71.276 33.035 71.156 33.035H68.363C68.3385 33.0321 68.3136 33.0348 68.2902 33.0429C68.2669 33.051 68.2457 33.0644 68.2282 33.0819C68.2108 33.0994 68.1976 33.1207 68.1896 33.1441C68.1816 33.1675 68.179 33.1924 68.182 33.217V34.027C68.179 34.0516 68.1816 34.0764 68.1896 34.0999C68.1976 34.1233 68.2108 34.1445 68.2282 34.1621C68.2457 34.1796 68.2669 34.193 68.2902 34.2011C68.3136 34.2092 68.3385 34.2119 68.363 34.209H70.494C70.614 34.209 70.661 34.29 70.661 34.409C70.661 34.528 70.614 34.591 70.494 34.591H68.363C68.338 34.5889 68.3129 34.5923 68.2894 34.6012C68.2659 34.6101 68.2447 34.6241 68.2273 34.6422C68.21 34.6603 68.1969 34.6821 68.1891 34.706C68.1812 34.7298 68.1788 34.7551 68.182 34.78V35.826C68.179 35.8505 68.1816 35.8755 68.1896 35.8989C68.1976 35.9223 68.2108 35.9436 68.2282 35.9611C68.2457 35.9786 68.2669 35.992 68.2902 36.0001C68.3136 36.0082 68.3385 36.0109 68.363 36.008H71.29C71.41 36.008 71.4571 36.069 71.4571 36.19C71.4571 36.311 71.41 36.39 71.29 36.39L67.962 36.391Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.909 35.481L76.949 36.149C76.962 36.331 76.949 36.392 76.682 36.392C76.328 36.392 76.282 36.352 76.275 36.122L76.255 35.596C76.228 34.982 75.747 34.84 74.885 34.833L73.442 34.819C73.335 34.819 73.268 34.846 73.268 34.981V36.15C73.268 36.332 73.255 36.393 72.981 36.393C72.674 36.393 72.667 36.332 72.667 36.15V32.998C72.667 32.741 72.76 32.647 73.048 32.647H75.301C76.243 32.647 76.865 32.847 76.865 33.578C76.865 34.104 76.731 34.361 76.17 34.496C76.063 34.523 75.989 34.53 75.989 34.618V34.638C75.989 34.738 76.063 34.738 76.176 34.766C76.642 34.866 76.882 35.035 76.909 35.481ZM75.165 32.997H73.441C73.334 32.997 73.267 32.99 73.267 33.139V34.313C73.267 34.434 73.334 34.461 73.441 34.461L74.871 34.447C75.646 34.427 76.228 34.433 76.228 33.732C76.228 33.105 75.934 32.997 75.165 32.997Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3609 17.834C37.827 14.9899 36.6193 12.3152 34.8389 10.034",
    stroke: "#003B8B",
    strokeWidth: 1.466,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4321 24.605C38.4321 24.605 37.8621 25.674 33.9271 25.236C31.2141 24.936 27.6331 24.436 23.7001 28.289C21.9894 30.1269 20.1811 31.8714 18.2831 33.515C17.6928 34.0521 16.9815 34.4387 16.2096 34.6417C15.4378 34.8447 14.6283 34.8582 13.8501 34.681C14.8519 35.0966 15.9466 35.2365 17.0206 35.0861C18.0947 34.9358 19.109 34.5007 19.9581 33.826C21.4521 32.799 25.9581 29.754 25.9581 29.754C25.9581 29.754 27.8761 28.342 32.8291 28.69C34.0911 28.779 37.1651 28.89 37.9651 27.09C38.3307 26.3146 38.4899 25.458 38.4271 24.603",
    fill: "url(#paint12_linear_3084_158)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1888 29.079C37.1888 29.079 36.6108 30.021 32.7688 29.755C30.8568 29.622 27.7488 29.467 25.2998 31.455C24.1318 32.401 21.5858 34.026 20.3218 34.845C18.3218 36.14 16.8318 37.132 10.7428 34.635C8.70853 33.8371 6.82009 32.7086 5.15381 31.295C7.79099 35.3371 11.9029 38.1892 16.6128 39.243C19.0258 39.7826 21.5235 39.8248 23.9534 39.3672C26.3833 38.9095 28.6944 37.9615 30.7458 36.581C33.5554 34.7362 35.7881 32.1368 37.1878 29.081",
    fill: "url(#paint13_linear_3084_158)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60424 6.83502C1.62524 10.964 1.08223 21.969 7.39723 25.67C14.8642 30.049 19.0792 22.63 19.0792 22.63C19.0792 22.63 11.3312 24.182 8.22823 18.855C5.17023 13.606 9.60424 6.83502 9.60424 6.83502Z",
    fill: "url(#paint14_linear_3084_158)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.068 27.174C11.816 28.634 14.547 28.274 16.996 26.316C19.445 24.358 21.779 21.487 25.202 21.858C26.8919 21.9685 28.4843 22.6888 29.683 23.885C28.7151 23.7016 27.7169 23.759 26.7764 24.0524C25.8359 24.3457 24.982 24.8658 24.29 25.567C22.19 27.944 18.27 33.967 12.948 33.967C7.626 33.967 0 24.936 0 24.936C0 24.936 2.642 25.815 7.068 27.173",
    fill: "url(#paint15_linear_3084_158)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M7.82921 30.417C7.08721 29.874 6.52021 29.46 6.07321 29.142C7.75321 30.13 10.9852 31.692 13.3872 30.842C11.9484 30.7798 10.5315 30.4671 9.20021 29.918C7.81533 29.4171 6.48593 28.7743 5.23321 28C5.23321 28 9.41421 30.014 12.0242 29.185C11.9773 29.1836 11.9306 29.1793 11.8842 29.172C4.99121 27.81 1.99121 26.026 1.99121 26.026C1.99121 26.026 8.10821 33.648 13.8112 32.96C14.501 32.732 15.133 32.3567 15.6632 31.86C15.6632 31.86 12.4342 33.785 7.82921 30.413",
    fill: "#00A3D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3084_158",
    x1: 22.156,
    y1: -1.32643,
    x2: 22.156,
    y2: 26.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3084_158",
    x1: 20.0537,
    y1: -1.31834,
    x2: 20.2692,
    y2: 26.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3084_158",
    x1: 25.4038,
    y1: -1.31771,
    x2: 25.679,
    y2: 26.6459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3084_158",
    x1: 29.8359,
    y1: -1.31531,
    x2: 30.174,
    y2: 26.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3084_158",
    x1: 25.4009,
    y1: -1.30615,
    x2: 44.4789,
    y2: 14.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3084_158",
    x1: 15.5879,
    y1: -1.31771,
    x2: 15.8631,
    y2: 26.6459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3084_158",
    x1: 15.0718,
    y1: -1.30599,
    x2: 27.1982,
    y2: 2.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3084_158",
    x1: 10.4761,
    y1: -1.31425,
    x2: 10.8142,
    y2: 26.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3084_158",
    x1: 9.89746,
    y1: 0.147888,
    x2: 24.7969,
    y2: 7.92809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFDA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#FFBC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F07A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#E7502B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF272A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3084_158",
    x1: 7.6878,
    y1: 19.149,
    x2: 34.0087,
    y2: 19.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3084_158",
    x1: 7.68446,
    y1: 22.676,
    x2: 34.0334,
    y2: 22.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3084_158",
    x1: 7.68011,
    y1: 20.638,
    x2: 34.013,
    y2: 20.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3084_158",
    x1: 37.3831,
    y1: 23.6437,
    x2: 34.6856,
    y2: 32.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141C4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3084_158",
    x1: 22.2285,
    y1: 27.1069,
    x2: 21.7564,
    y2: 39.6231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#905024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#532519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3084_158",
    x1: 15.8815,
    y1: 30.3891,
    x2: 9.20506,
    y2: 22.5546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3084_158",
    x1: 19.2643,
    y1: 28.0055,
    x2: 14.2773,
    y2: 19.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitycenterColored);
export default __webpack_public_path__ + "static/media/citycenter_colored.578c8bc719700d93656d4ba3d4689b74.svg";
export { ForwardRef as ReactComponent };